// Main TypeScript Entry Point
import { App } from "./app";
import { DialogManager } from "./components/dialogs/dialog-manager";
import { AuthManager } from "./services/auth-manager";
import { I18nManager } from "./services/i18n-manager";
import { ProductService } from "./services/product-service";
import { ThemeManager } from "./services/theme-manager";
import { CartManager } from "./state/cart-manager";
// Register custom elements
import "./components/image-loader";

// Initialize the application
document.addEventListener("DOMContentLoaded", () => {
  const app = new App();
  app.init();

  // Register Service Worker (best-effort)
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // no-op if registration fails
    });
  }
});

// Export for debugging
(window as any).App = App;
(window as any).DialogManager = DialogManager;
(window as any).CartManager = CartManager;
(window as any).AuthManager = AuthManager;
(window as any).ProductService = ProductService;
(window as any).I18nManager = I18nManager;
(window as any).ThemeManager = ThemeManager;
